<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>소식 알림</p></li>
            <li><p>공지 사항</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>공지 사항</span>
          </h1>
        </div>
        <news-view :item="item" :files="files" />
        <div class="page_btn">
          <button class="btn" @click="fnBack">목록으로</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import NewsView from '@/components/pages/news/view/index'

export default {
  name: 'manager-exam-notice-view',
  components: { NewsView },
  description: '공지사항 - 상세',
  data: function() {
    const query = this.$route.query
    return {
      params: {
        noticeNo: Number(query.noticeNo)
      },
      item: {},
      files: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function() {
      const res = await this.$ManagerSvc.getMapExamNotice(this.params)
      if (res.code === 1) {
        this.item = res.entity.notice
        this.files = res.entity.files
      }
    },
    fnBack: function() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped></style>
